import { render, staticRenderFns } from "./mourningArticle.vue?vue&type=template&id=6e43e4e0&scoped=true&"
import script from "./mourningArticle.vue?vue&type=script&lang=js&"
export * from "./mourningArticle.vue?vue&type=script&lang=js&"
import style0 from "./mourningArticle.vue?vue&type=style&index=0&id=6e43e4e0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.7@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e43e4e0",
  null
  
)

export default component.exports